import { fetchWithAuth } from '../utils/fetchWithAuth';

const API_URL = import.meta.env.VITE_API_URL;

export async function getAppMovilConfig() {
  const r = await fetch(`${API_URL}/app-movil/config`, { method: 'GET' });
  if (!r.ok) throw new Error(await r.text());
  return r.json();
}

export async function updateAppMovilConfig(enabled) {
  const r = await fetchWithAuth(`/admin/settings/app-movil`, {
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ enabled }),
  });
  if (!r.ok) throw new Error(await r.text());
  return r.json();
}
